export let GoalType;(function(a){a.Message="message",a.Url="url",a.File="file"})(GoalType||(GoalType={}));